module.exports = __webpack_public_path__ + "img/ico_control.295b36ce.svg";